import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';
import { GOAL_OPERATOR_TYPES_STRING_VALUES, CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';

import template from './goal-setting-column.pug';

export class GoalSettingColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, newI18n }) {
    super({
      name: 'GoalSetting',
      property: 'GoalSetting',
      title: i18n.getString('Details_View_Goal_Setting'),
      bodyClasses: ['grid-column-goalSetting', 'actionable'],
      colClasses: ['col-longText'],
      type: 'string',
    });
    this.i18n = i18n;
    this.newI18n = newI18n;
  }

  template({
    value: {
      Opportunities,
    },
  }) {
    const opportunity = _.first(Opportunities);
    const goalTypeCode = opportunity.GoalTypeCode;
    let suggestedGoal;
    if (goalTypeCode === 'DestinationGoal') {
      const { SuggestedGoal } = opportunity;
      suggestedGoal = {
        destinationUrl: SuggestedGoal.DestinationUrl,
        destinationURLOperator: this.i18n.getString(GOAL_OPERATOR_TYPES_STRING_VALUES[
          SuggestedGoal.DestinationURLOperator
        ]),
      };
    } else if (goalTypeCode === 'EventGoal') {
      const {
        Category,
        CategoryOperator,
        Action,
        ActionOperator,
        Label,
        LabelOperator,
        Value,
        ValueOperator,
      } = opportunity.SuggestedEventGoal;
      suggestedGoal = {
        CategoryTitle: `${this.newI18n.getString(_TL_('Category'))} :`,
        Category,
        CategoryOperator: !_.isUndefined(GOAL_OPERATOR_TYPES_STRING_VALUES[CategoryOperator])
          && `${this.i18n.getString(GOAL_OPERATOR_TYPES_STRING_VALUES[CategoryOperator])} `,
        ActionTitle: `${this.newI18n.getString(_TL_('Action'))} :`,
        Action,
        ActionOperator: !_.isUndefined(GOAL_OPERATOR_TYPES_STRING_VALUES[ActionOperator])
          && `${this.i18n.getString(GOAL_OPERATOR_TYPES_STRING_VALUES[ActionOperator])} `,
        LabelTitle: `${this.newI18n.getString(_TL_('Label'))} :`,
        Label,
        LabelOperator: !_.isUndefined(GOAL_OPERATOR_TYPES_STRING_VALUES[LabelOperator])
          && `${this.i18n.getString(GOAL_OPERATOR_TYPES_STRING_VALUES[LabelOperator])} `,
        ValueTitle: `${this.newI18n.getString(_TL_('Value'))} :`,
        Value,
        ValueOperator: !_.isUndefined(GOAL_OPERATOR_TYPES_STRING_VALUES[ValueOperator])
          && `${this.i18n.getString(GOAL_OPERATOR_TYPES_STRING_VALUES[ValueOperator])} `,
      };
    } else if (goalTypeCode === 'ClarityEventGoal') {
      const { ConversionClarityButtons } = opportunity.SuggestedClarityEventGoal;
      const {
        IsFromMultipleURL,
        SourceURL,
        Text,
      } = _.first(ConversionClarityButtons);

      const buttonTextElement = `<span id="clarityEventButtonText">"${Text}"</span>`;
      const clarityEventGoalSetting = this.newI18n.getString(_TL_('Button {0} on {1}')).replace('{0}', buttonTextElement).replace('{1}', SourceURL)
        + (IsFromMultipleURL ? this.newI18n.getString(_TL_(' and other similar websites')) : '');
      suggestedGoal = {
        clarityEventGoalSetting,
        conversionClarityButtonsCount: _.size(ConversionClarityButtons),
        moreConversionClarityButtons: withContextualAttributeTemplate({
          opportunityId: opportunity.OpportunityId,
          entityName: ` +${this.i18n.getString('Recommendation_Grid_Todo_More', { count: _.size(ConversionClarityButtons) - 1 })}`,
          entityId: `${opportunity.OpportunityId}_moreConversionClarityButtons`,
          entityType: CONTEXTUAL_ENTITY_TYPE.MORE_CONVERSION_CLARITY_BUTTONS,
          status: 'false',
        }),
      };
    }

    return template({
      suggestedGoal,
      goalTypeCode,
    });
  }

  get property() {
    return {
      get: _.identity,
      property: 'GoalSetting',
    };
  }
}
